import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { urlHashDatePicker } from 'constants/url'
import { EmptyObject } from 'lib/object/objectUtils'
import offerPageURL from 'lib/offer/offerPageURL'
import { buildSearchParamsFromFilters } from 'lib/search/searchUtils'
import React, { useMemo } from 'react'
import { OfferUnavailableReason } from 'lib/search/constants'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  unavailableReason: string | undefined
  filters?: App.OfferListFilters
}

function BedbankSearchTileUnavailabilityBanner({
  offer,
  unavailableReason,
  filters = EmptyObject,
}: Props) {
  const offerUrl = useMemo(() => {
    const searchParams = buildSearchParamsFromFilters({
      ...filters,
      checkIn: undefined,
      checkOut: undefined,
    })

    if (unavailableReason === OfferUnavailableReason.CAPACITY_EXCEEDED) return offerPageURL(offer, searchParams)

    return offerPageURL(offer, searchParams) + urlHashDatePicker
  }, [filters, offer, unavailableReason])

  const bannerMessage = useMemo(() => {
    if (unavailableReason === OfferUnavailableReason.CAPACITY_EXCEEDED) {
      return 'Unavailable for the number of guests selected'
    }
    return 'Unavailable for your dates'
  }, [unavailableReason])

  return <MessageBanner
    kind="informational-primary"
    description={<b>{bannerMessage}</b>}
    primaryActionButtonProps={{
      children: unavailableReason === OfferUnavailableReason.CAPACITY_EXCEEDED ? 'View offer' : 'View available dates',
      to: offerUrl,
    }}
  />
}

export default BedbankSearchTileUnavailabilityBanner
